export const viewTypes = ["subscription-offers", "standing-offers"] as const;
export type ViewType = (typeof viewTypes)[number];
